<template>
<div class="charts-group">
  <div v-if="showHeader" class="charts-group-header">
    <h3 class="year">{{data.label}}</h3>
    <div class="statistical-wrapper">
      <template v-for="(n, index) in data[factorId]">
        <label :key="`label-${index}`" :index="index"></label>
        <span :key="`value-${index}`" :index="index">{{n}}</span>
      </template>
    </div>
  </div>
  <div class="charts-group-body">
    <aqi-hourly-chart
      v-for="month in data.months"
      :key="month.value"
      :data="month"
      :factor-id="factorId"
    />
  </div>
</div>
</template>

<script>
import AqiHourlyChart from './AqiHourlyChart'

export default {
  name: 'ChartsGroup',
  components: {AqiHourlyChart},
  props: {
    data: {
      required: true,
      type: Object
    },
    showHeader: {
      type: Boolean
    },
    factorId: {
      required: true,
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.charts-group {
  .year {
    margin: 0;
    text-align: center;
    color: #cccccc;
  }

  .charts-group-body {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
  }

  .statistical-wrapper {
    font-size: 12px;
    display: grid;
    grid-template-columns: repeat(6, max-content);
    justify-content: center;
    align-items: center;
    grid-column-gap: 5px;
    padding: 5px 0;
    line-height: 20px;
    /*text-shadow: 1px 1px 1px rgba(0, 0, 0, .35);*/
    -webkit-text-stroke: 1px rgba(0, 0, 0, .25);

    > label {
      padding-left: 5px;
    }

    > label[index="0"] {
      color: rgb(0, 228, 0);

      &:before {
        content: "优:"
      }
    }

    > label[index="1"] {
      color: rgb(255, 255, 0);

      &:before {
        content: "良:"
      }
    }

    > label[index="2"] {
      color: rgb(255, 126, 0);

      &:before {
        content: "轻度:"
      }
    }

    > label[index="3"] {
      color: rgb(255, 0, 0);

      &:before {
        content: "中度:"
      }
    }

    > label[index="4"] {
      color: rgb(153, 0, 76);

      &:before {
        content: "重度:"
      }
    }

    > label[index="5"] {
      color: rgb(126, 0, 35);

      &:before {
        content: "严重:"
      }
    }

    > span {
      padding-right: 5px;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/04AQI/09PollutionFeature/ChartsGroup.vue